'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

CommandButtonDirective=class CommandButtonDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['command'];
}

get textBindings(){
return['text','inProgressText','completionText'];
}

get templateUrl(){
return'/templates/directives/commandButtonDirective/commandButtonTemplate';
}

get controller(){
return CommandButtonDirectiveController;
}};let


CommandButtonDirectiveController=class CommandButtonDirectiveController{
static get $inject(){
return[];
}

constructor(){
this.completionText=this.completionText||'';
}

get showDefaultText(){
return!this.command.inProgress&&!this.command.completed;
}

get showInProgressText(){
return this.command.inProgress||this.command.completed&&this.completionText.length===0;
}

get showCompletionText(){
return this.command.completed&&this.completionText.length>0;
}};



module.exports=CommandButtonDirective;
module.exports.controller=CommandButtonDirectiveController;
//# sourceMappingURL=commandButtonDirective.js.map
